import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { SuccessButton, SuccessButtonWhiteBg } from 'components/button';
import { COLOR } from 'constants/colors';
import { get, getDefaultHeaders, getFormDataFromJson, fetchPost } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { getEncryptedUserId, getQueryParamsFromString, isBtoCFlow, isFlowTypeCheckout, isFlowTypeProfile } from '__utils/common-utils';
import { ENDPOINTS } from 'constants/endpoints';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps } from '__utils/type';
import { useForm } from 'react-hook-form';
import useFlashToggler from 'hooks/use-flash-toggler';import styled from 'styled-components';
import surveyMan from 'images/survey-man.svg';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import CartSelector from 'views/cart/cart.selector';
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector } from 'react-redux';
import { getAgentCode, getUserDetails } from '__utils/storage';
import Footer from 'components/footer';
import MobileFooterLayout from 'components/old-footer-layout';

const RiskSurveyContainer = styled.div <CommonStyledComponentProps>`
    display: block;
    .radioDiv{
        padding-left: 0;
        margin-top: 0;
        margin-bottom: 0px;
        width: ${(props: any) => props.isMobile ? "auto" : "350px"}
    }
    .question-header{
        font-size: 16px;
        font-weight: 500;
        margin-top: 20px;
        width: ${(props: any) => props.isMobile ? "280px" : "624px"}
    }
    .w-400{
        font-size: 16px;
        font-weight: 500;
        width: ${(props: any) => props.isMobile ? "280px" : "450px"}
    }
    .answerRadioBtns input{
        width:unset;
    }
`;
const SubmitButton = styled(SuccessButton) <CommonStyledComponentProps>`
        margin-top: 1rem; 
        width: 123px;
        font-size: 14px; 
        height: 40px;
        border: 1px solid ${COLOR.GREEN};
        &:disabled {
            background: ${COLOR.DISABLED_BTN} !important;
            cursor: default;
            color: #fff;
            border: 1px solid ${COLOR.DISABLED_BTN};

        }
`;
const SuccessBtnWhite = styled(SuccessButtonWhiteBg) <CommonStyledComponentProps>`
    width: 123px;
    font-size: 14px; 
    border: 1px solid ${COLOR.GREEN};
    height: 40px;
    &:disabled {
        background: ${COLOR.DISABLED_BTN} !important;
    }
    &:disabled:hover {
        background: ${COLOR.DISABLED_BTN} !important;
        cursor: default;
        color: #fff;
    }
`;

const RiskSurvey: React.FC = () => {
    const history = useHistory();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { cartDetails } = propsToJS(useSelector(CartSelector));
    const { userType } = getQueryParamsFromString(window.location.search);
    const { register, handleSubmit, trigger, formState } = useForm({ mode: 'onChange' });
    const [ answerTypes, setAnswerTypes ] = useState<any>();
    const [ questionSet, setquestionSet ] = useState<any>();
    const [ currentQuestion, setCurrentQuestion ] = useState<any>();
    const [ currentAnswerOptions, setCurrentAnswerOptions ] = useState<any>();
    const [ riskProfileVersion, setRiskProfileVersion ] = useState<any>();
    const [ riskProfileView, setRiskProfileView ] = useState<any>({});
    const [ maxuserAttemptId, setMaxUserAttemptId ] = useState<any>();
    const [ answerChecked, setAnswerChecked ] = useState<any>();
    const [ completeAns, setCompleteAns ] = useState<boolean>();
    const { userAttemptId } = getQueryParamsFromString(window.location.search);
    const flash = useFlashToggler();
    
    useEffect(() => {
        fetchAnswerTypes();
    }, []);

    useEffect(() => {
        matchCurrentAnswerOptions(currentQuestion);
        riskProfileVersion && fetchRiskProfile(riskProfileVersion, currentQuestion, maxuserAttemptId);
        setCompleteAns(undefined);
    }, [ currentQuestion ]);

    const setCurrentQuestionValue = (question: any, riskProfileVersion: any) => {
        matchCurrentAnswerOptions(question);
        setCurrentQuestion(question);
        fetchMaxAttemptId(riskProfileVersion, question);
        setRiskProfileVersion(riskProfileVersion);
    }
    const matchCurrentAnswerOptions = (ques: any) => {
        let newArray = answerTypes?.filter((element: any) => {
            return element?.questionNo === ques?.questionNo
        });
        setCurrentAnswerOptions(newArray);
    }
    const fetchMaxAttemptId = (riskProfileVersion: any, question: any) => {
        get(`${ENDPOINTS.GET_RISK_PROFILE_MAX_USER_ATTEMPT_ID}/${getEncryptedUserId()}?risk-profile-version=${riskProfileVersion}`, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                fetchRiskProfile(riskProfileVersion, question, userAttemptId ? userAttemptId : response?.response?.data ? (response?.response?.data) : 1);
                setMaxUserAttemptId(userAttemptId ? userAttemptId : response?.response?.data ? (response?.response?.data) : 1);
            }, (error: AjaxError) => {
                flash.error('Something went wrong.Please try again later');
            });
    }
    const fetchAnswerTypes = () => {
        get(`${ENDPOINTS.GET_RISK_PROFILE_ANSWER_OPTIONS}`, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                setAnswerTypes(response?.response?.data);
                fetchQuestions();
            }, (error: AjaxError) => {
                flash.error('Something went wrong.Please try again later');
            });
    }

    const fetchQuestions = () => {
        get(`${ENDPOINTS.GET_RISK_PROFILE_QUESTIONS}`, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                setquestionSet(response?.response?.data);
                setCurrentQuestionValue(response?.response?.data[ 0 ], response?.response?.data[ 0 ]?.riskProfileVersion);
            }, (error: AjaxError) => {
                flash.error('Something went wrong.Please try again later');
            });
    }

    const fetchRiskProfile = (riskProfileVersion?: number, question?: any, attemptId?: any) => {
        get(`${ENDPOINTS.GET_RISK_PROFILE}/${getEncryptedUserId()}?risk-profile-version=${riskProfileVersion}&question-no=${question?.questionNo}&user-attempt-id=${attemptId}`, getDefaultHeaders(), false)
            .subscribe((response: AjaxResponse | AjaxError) => {
                let newArray = [];
                newArray[ response?.response?.data[ response?.response?.data?.length - 1 ]?.questionNo ] = response?.response?.data[ response?.response?.data?.length - 1 ]?.answerOptionId;
                setRiskProfileView(newArray);
                trigger("answer");
                setCompleteAns(response?.response?.data[ response?.response?.data?.length - 1 ]?.answerOptionId);
                setAnswerChecked(response?.response?.data[ response?.response?.data?.length - 1 ]?.answerOptionId);
            }, (error: AjaxError) => {
                flash.error('Something went wrong.Please try again later');
            });
    }
    const checkOption = (question: number, optionValue: number) => {
        return riskProfileView[ question ] === optionValue;
    }
    const indexofQuestion = () => {
        return questionSet?.indexOf(currentQuestion);
    }
    const gotoPrev = () => {
        indexofQuestion() > 0 && setCurrentQuestion(questionSet[ indexofQuestion() - 1 ]);
    }
    const onSubmitAnswers = (answerEvent: any, calculateRiskScore: boolean) => {
        setCompleteAns(answerEvent);
        setAnswerChecked(answerEvent);
        const riskProfileData = getFormDataFromJson({
            questionNo: currentQuestion?.questionNo,
            answerOptionId: parseInt(answerEvent),
            riskProfileVersion: riskProfileVersion,
            totalQuestionsCount: questionSet?.length,
            userAttemptId: maxuserAttemptId,
            isCalculateRiskScore: calculateRiskScore
        });
        fetchPost(
            `${ENDPOINTS.GET_RISK_PROFILE}/${getEncryptedUserId()}`, riskProfileData, null, true
        ).then((response: any) => {
            if (response?.meta?.statusCode === 200)
            {
                proceedToNext();
                if (calculateRiskScore === true)
                {
                    history.push(isFlowTypeCheckout() ? (userType === 'old' ? '/profile/risk-profile-result?flowType=checkout&userType=old' : '/profile/risk-profile-result?flowType=checkout') : '/profile/risk-profile-result?flowType=profile');
                }
            }
            else
            {
                flash.error('Something went wrong.Please try again later');
            }
        });
    }

    const proceedToNext = () => {
        if (indexofQuestion() === questionSet?.length - 1)
        {
            fetchRiskProfile(riskProfileVersion, currentQuestion, maxuserAttemptId);
        }
        else
            setCurrentQuestion(questionSet[ indexofQuestion() + 1 ]);
    }

    const nextPage = () => {
        Mixpanel.track(getEventName("riskProfileInfo", "completed", "checkout"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isBtoCFlow: isBtoCFlow(),
        });
        onSubmitAnswers(answerChecked, true);
    }
    const checkAns = (ans: any, single: any) => {
        if (ans === single) return true

    }
    return (
        <RiskSurveyContainer isMobile={ isMobile }>
            <form name="riskDetailsForm" onSubmit={ handleSubmit(proceedToNext) }>
                <div className={ isMobile ? "" : "rowFlex" }>
                    <div>
                        <div className={ isFlowTypeCheckout() ? ((cartDetails && cartDetails?.noOfItems > 0) ? "w-400" : "question-header") : "w-400" }>
                            { currentQuestion?.description }
                        </div>
                        <ul className="Custradio floatnone newCustradio radioDiv" >
                            {
                                currentAnswerOptions?.map((element: any, index: number) => (
                                    <>
                                        <li className="answerRadioBtns" key={ index }>
                                            <input
                                                name='answer'
                                                type="radio"
                                                id="answer"
                                                value={ element?.answerOptionId }
                                                checked={ checkOption(currentQuestion?.questionNo, element?.answerOptionId) /* completeAns && checkAns(completeAns,element?.answerOptionId) */ }
                                                ref={register({
                                                    required: "This is a mandatory question.",
                                                }) }
                                                onChange={ (e: any) => onSubmitAnswers(e.target.value, false) }
                                            /><span></span>
                                            <em style={ { marginLeft: "15px" } }>{ element?.answerDescription }</em>
                                        </li>
                                    </>
                                ))
                            }
                            <div style={ { padding: "0", marginBottom: "200px" } }></div>
                        </ul>
                        <div className={ isMobile ? 'disp-flex' : 'disp-flex-desktop' }>
                            <SuccessBtnWhite isMobile={ isMobile }
                                disabled={ indexofQuestion() === 0 }
                                onClick={ () => gotoPrev() }
                                type="button">Previous</SuccessBtnWhite>
                            { (indexofQuestion() === questionSet?.length - 1) ? <SubmitButton isMobile={ isMobile } onClick={ nextPage } disabled={!completeAns}>Submit</SubmitButton> :
                                <SubmitButton isMobile={ isMobile } disabled={ !formState.isValid } type="submit" >Next</SubmitButton> }
                        </div>
                    </div>
                    { !isMobile && <object data={ surveyMan } style={ { width: "300px" } }></object> }
                </div>
            </form>
            <div className="riskprogressBar" style={ { marginTop: !isMobile ? "100px" : "", minWidth: isMobile ? "80vw" : "50vw" } }>
                { questionSet?.map((elem: any, index: number) => (
                    <div className="progressDiv" key={ index } style={ { backgroundColor: index <= (indexofQuestion()) ? '#00A465' : '' } }>

                    </div>

                )) }
                { isMobile &&
                    <>
                        { isFlowTypeProfile() && <Footer>
                            <MobileFooterLayout />
                        </Footer> }
                    </>
                }
            </div>


        </RiskSurveyContainer>
    );
};

export default RiskSurvey;
